import React, { Component, Fragment } from 'react'
import { Query } from 'react-apollo'

import { SELF_QUERY } from '../../queries'

import Hero from '../../components/Hero/'
import Breadcrumb from '../../components/Breadcrumb/'
import Appointments from '../../components/Appointments/'
import Loader from '../../components/Loader/'
import Error from '../../components/Error/'
import withHeaderFooter from '../../wrapper/withHeaderFooter'

import { Container } from '../../styles/defaults'

import helpers from '../../helpers'

import hero from '../../assets/hero/agenda/hero.jpg'

class Agenda extends Component {
  render() {
    const { portalOrder, servicePackage, nextDeliveryDate } = this.props
    let notifications = helpers.getNotifications(portalOrder, [], [], servicePackage, nextDeliveryDate)

    return (
      <Fragment>
        <Hero small={hero} medium={hero} large={hero} retina={hero} title="Agenda" />
        <Breadcrumb title="Agenda" />
        <Query query={SELF_QUERY}>
          {({ loading, error, data }) => {
            if (loading) return <Loader from="25%" to="100%" />
            if (error) return <Error error="uw gebruikersgegevens" />
            const { self } = data
            let viewAgenda = (self.permissions.includes('VIEW_AGENDA') || self.role === 'MANAGER') && !this.props.branch.suspended
            if (viewAgenda) {
              return <Appointments appointments={notifications.appointments} />
            } else {
              return (
                <Container mt mb>
                  Onvoldoende rechten om de agenda te bekijken
                </Container>
              )
            }
          }}
        </Query>
      </Fragment>
    )
  }
}

export default withHeaderFooter(Agenda)



// WEBPACK FOOTER //
// ./src/views/Agenda/index.js